var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"start-placeholder":"απο","end-placeholder":"εως","value-format":"timestamp","format":_vm.displayFormat,"type":_vm.type,"picker-options":_vm.pickerOptions},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }